import { API_BASE } from "@/lib/api";

// Costa Rica no tiene horario de verano: -06:00 fijo.
const CR_OFFSET = "-06:00";

const utcStamp = (date, hhmm) => {
  const d = new Date(`${date}T${hhmm || "00:00"}:00${CR_OFFSET}`);
  return d.toISOString().replace(/[-:]/g, "").replace(/\.\d{3}Z$/, "Z");
};

const isoZ = (date, hhmm) => new Date(`${date}T${hhmm || "00:00"}:00${CR_OFFSET}`).toISOString(); // tz-ok: el offset de CR va explícito

export function liveSessionEvent(s, lang = "es") {
  const lines = [`WSS Live · ${s.title || ""}`];
  if (s.teacher_name) lines.push(`${lang === "en" ? "Teacher" : "Profesor/a"}: ${s.teacher_name}`);
  if (s.meet_link) lines.push(`${lang === "en" ? "Join" : "Enlace de la clase"}: ${s.meet_link}`);
  return {
    title: `WSS Live · ${s.title || ""}`,
    date: s.date,
    start: s.start_time,
    end: s.end_time || s.start_time,
    details: lines.join("\n"),
    location: s.meet_link || "",
  };
}

export function googleEventUrl(ev) {
  const q = new URLSearchParams({
    action: "TEMPLATE",
    text: ev.title,
    dates: `${utcStamp(ev.date, ev.start)}/${utcStamp(ev.date, ev.end)}`,
    details: ev.details || "",
    ctz: "America/Costa_Rica",
  });
  if (ev.location) q.set("location", ev.location);
  return `https://calendar.google.com/calendar/render?${q}`;
}

export function outlookEventUrl(ev) {
  const q = new URLSearchParams({
    path: "/calendar/action/compose",
    rru: "addevent",
    subject: ev.title,
    startdt: isoZ(ev.date, ev.start),
    enddt: isoZ(ev.date, ev.end),
    body: ev.details || "",
  });
  if (ev.location) q.set("location", ev.location);
  return `https://outlook.live.com/calendar/0/deeplink/compose?${q}`;
}

export const liveIcsUrl = (sessionId, token) =>
  `${API_BASE}/api/calendar/sync/live/${sessionId}.ics?t=${encodeURIComponent(token)}`;
